import { Geo2 } from "./geography.position";
export class KnownPlaces {
    static FillSelectElement(select, places, callback) {
        const unselectedOption = document.createElement("option");
        unselectedOption.value = "";
        unselectedOption.disabled = true;
        unselectedOption.selected = true;
        unselectedOption.textContent = "Select a location...";
        select.appendChild(unselectedOption);
        for (const [category, locations] of Object.entries(places)) {
            const optgroup = document.createElement("optgroup");
            optgroup.label = category;
            const entries = Object.entries(locations);
            const sortedEntries = entries.sort((a, b) => a[0].localeCompare(b[0]));
            for (const [name, coords] of sortedEntries) {
                const option = document.createElement("option");
                option.value = Geo2.ToString(coords);
                option.text = name;
                optgroup.appendChild(option);
            }
            select.appendChild(optgroup);
        }
        select.onchange = () => {
            const selectedOption = select.options[select.selectedIndex];
            const coords = Geo2.Parse(selectedOption.value);
            callback(selectedOption.text, coords);
        };
        return select;
    }
}
KnownPlaces.Mountains = {
    Everest: new Geo2(27.9881, 86.925),
    K2: new Geo2(35.8808, 76.5155),
    Kangchenjunga: new Geo2(27.7025, 88.1475),
    Lhotse: new Geo2(27.9617, 86.9333),
    Makalu: new Geo2(27.8897, 87.0889),
    ChoOyu: new Geo2(28.0942, 86.6608),
    Dhaulagiri: new Geo2(28.6967, 83.4872),
    Manaslu: new Geo2(28.5494, 84.5599),
    NangaParbat: new Geo2(35.237, 74.5892),
    Annapurna: new Geo2(28.5961, 83.8203),
    Matterhorn: new Geo2(45.9763, 7.6586),
    MontBlanc: new Geo2(45.8326, 6.8652),
    Denali: new Geo2(63.0695, -151.0074),
    Aconcagua: new Geo2(-32.6532, -70.0109),
    Kilimanjaro: new Geo2(-3.0674, 37.3556),
    Elbrus: new Geo2(43.3499, 42.4375),
    PuncakJaya: new Geo2(-4.0751, 137.1889),
    Roraima: new Geo2(5.125, -60.75),
};
KnownPlaces.Volcanoes = {
    Krakatoa: new Geo2(-6.102, 105.423),
    Vesuvius: new Geo2(40.821, 14.426),
    Etna: new Geo2(37.751, 14.993),
    MaunaLoa: new Geo2(19.475, -155.608),
    Kilauea: new Geo2(19.421, -155.287),
    Fuji: new Geo2(35.3606, 138.7274),
    StHelens: new Geo2(46.1912, -122.1944),
    Pinatubo: new Geo2(15.142, 120.35),
    Rainier: new Geo2(46.853, -121.76),
    Cotopaxi: new Geo2(-0.679, -78.438),
    Popocatepetl: new Geo2(19.023, -98.622),
    Eyjafjallajokull: new Geo2(63.633, -19.621),
    Santorini: new Geo2(36.404, 25.396),
    Kilimanjaro: new Geo2(-3.067, 37.355),
    Arenal: new Geo2(10.463, -84.703),
    Yellowstone: new Geo2(44.428, -110.588),
    Tambora: new Geo2(-8.25, 118.0),
    Sakurajima: new Geo2(31.593, 130.657),
};
KnownPlaces.SightsAndParks = {
    GrandCanyon: new Geo2(36.1069, -112.1129),
    Yellowstone: new Geo2(44.428, -110.5885),
    GreatBarrierReef: new Geo2(-18.2871, 147.6992),
    Yosemite: new Geo2(37.8651, -119.5383),
    Serengeti: new Geo2(-2.3333, 34.8333),
    MachuPicchu: new Geo2(-13.1631, -72.545),
    Banff: new Geo2(51.1784, -115.5708),
    Galapagos: new Geo2(-0.9538, -90.9656),
    TorresDelPaine: new Geo2(-51.1667, -73.2425),
    PlitviceLakes: new Geo2(44.8803, 15.6161),
    VictoriaFalls: new Geo2(-17.9243, 25.8573),
    Santorini: new Geo2(36.3932, 25.4615),
    Petra: new Geo2(30.3285, 35.4444),
    IguazuFalls: new Geo2(-25.6953, -54.4367),
    Kruger: new Geo2(-23.9884, 31.5547),
    BryceCanyon: new Geo2(37.593, -112.1871),
    CliffsOfMoher: new Geo2(52.9715, -9.4265),
    AngkorWat: new Geo2(13.4125, 103.8669),
    HaLongBay: new Geo2(20.9101, 107.1839),
};
KnownPlaces.WorldWonders = {
    CliffsOfMoher: new Geo2(52.9715, -9.4265),
    Everest: new Geo2(27.9881, 86.925),
    Galapagos: new Geo2(-0.9538, -90.9656),
    GrandCanyon: new Geo2(36.1069, -112.1129),
    GreatBarrierReef: new Geo2(-18.2871, 147.6992),
    HaLongBay: new Geo2(20.9101, 107.1839),
    Kilimanjaro: new Geo2(-3.0674, 37.3556),
    Matterhorn: new Geo2(45.9763, 7.6586),
    Roraima: new Geo2(5.125, -60.75),
    TorresDelPaine: new Geo2(-51.1667, -73.2425),
    Vesuvius: new Geo2(40.821, 14.426),
    Yellowstone: new Geo2(44.428, -110.5885),
};
KnownPlaces.Wonders = {
    AngkorWat: new Geo2(13.4125, 103.8669),
    MachuPicchu: new Geo2(-13.1631, -72.545),
    Petra: new Geo2(30.3285, 35.4444),
};
KnownPlaces.Waterfalls = {
    IguazuFalls: new Geo2(-25.6953, -54.4367),
    VictoriaFalls: new Geo2(-17.9243, 25.8573),
};
//# sourceMappingURL=geography.knownPlaces.js.map